import { WebsiteModel } from "@insite/client-framework/Types/ApiModels";
import useStructuredData from "@store/Hooks/StructuredData/useStructuredData";
import { useWebsite } from "@store/Hooks/useWebsite/useWebsite";
import { Organization, PostalAddress } from "@store/Schemas/structuredData";
import { FC, useEffect, useState } from "react";

const OrganizationStructuredData: FC = () => {
    const [data, setData] = useState<Organization>();
    const website = useWebsite();

    useEffect(() => {
        if (!website || !window?.location) {
            return;
        }

        setData({
            "@type": "Organization",
            name: website.name,
            url: window.location.href,
            description: website.description,
            address: getAddress(website as WebsiteModel),
            logo: `${window.location.origin}/UserFiles/Images/Logo.png`,
        });
    }, [website]);

    useStructuredData(data);

    return null;
};

export const getAddress = (website: WebsiteModel): PostalAddress => {
    // We are reading custom properties data because website object don't have company information data included. There is a ticket pending that request the missing data: https://support.episerver.com/hc/en-us/requests/621385
    let streetAddress = website.properties?.companyInformationAddress1;

    if (website.properties?.companyInformationAddress2) {
        streetAddress = `${streetAddress}, ${website.properties?.companyInformationAddress2}`;
    }

    const address: PostalAddress = {
        "@type": "PostalAddress",
        addressRegion: website.properties?.companyInformationState,
        postalCode: website.properties?.companyInformationPostalCode,
        addressCountry: website.properties?.companyInformationCountry,
        addressLocality: website.properties?.companyInformationCity,
        streetAddress,
    };

    return address;
};

export default OrganizationStructuredData;
